<template>
  <div class="card-list-item product-item">
    <div class="helper-button" v-on:click="addProductToBasket"></div>
    <div class="card-item-main-wrap">
      <div class="card-item-main">
        <div class="card-item-image" v-if="product.file_id" :style="{ backgroundImage: 'url('+productImage+')'}"></div>
        <div :class="'card-item-title product-item-title' + (product.file_id ? ' has-image' : ' no-image')">
          <div class="card-item-name-wrap"><span class="card-item-name product-item-name" v-if="displayName === 'both' || !displayName">{{ $filters.posname(product) }}</span><span class="card-item-name product-item-name" v-if="displayName === 'product'">{{ product.name }}</span><span class="card-item-name product-item-name" v-if="displayName === 'marketing'">{{ $filters.marketingname(product) }}</span><span class="cart-item-warehousecount product-item-warehousecount" v-if="parseInt(product.allow_sale_under_warehouse) == 0"> ({{ parseInt(product.allow_sale_under_warehouse) ?  '' : product.warehouse_count }})</span></div>
          <span v-if="product" class="card-item-price product-item-price"><span v-if="parseInt(product.multiple_prices)">{{ _('From') }} </span>{{ $filters.currency(displayedPrice, product.currency) }}<span v-if="!hasHiddenUnits"> / {{ currentUnitStr }}</span></span>
        </div>
      </div>
      <a class="view-button btn btn-default" v-on:click="showPreviewModal"><span class="fa fa-fw fa-info"></span></a>
    </div>

    <div class="product-item-footer card-item-footer">
      <div class="input-group product-item-button card-item-button">
        <multiselect v-model="productCount" :options="productCountValues" :multiple="false" :show-labels="false" :searchable="false" :allow-empty="false"></multiselect>
        <span class="input-group-btn">
          <button class="btn btn-info" v-on:click="addProductToBasket"><span class="text-large">{{ _('Add') }}</span><span class="text-small"><span class="fa fa-fw fa-shopping-basket"></span></span></button>
        </span>
      </div>
    </div>
    <modal :name="previewModalId" :adaptive=true :width=1000 :maxWidth=1000 :maxHeight=500 :scrollable=true height="auto">
      <product-popup :product="product" :shopId="productShopId" :productShopId="productShopId" :baseDomain="baseDomain" :locale="locale" v-on:close="hidePreviewModal"></product-popup>
    </modal>
  </div>  
</template>

<script>

import errors from '~/lib/errors'
import Multiselect from 'vue-multiselect'
// import ProductPopup from '~/components/ProductPopup.vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      productCount: 1
    }
  },
  mixins: [ errors ],
  props: ['product', 'productShopId', 'baseDomain', 'column', 'activeComponent', 'displayName'],
  components: {
    Multiselect,
  },
  computed: {
    ...mapGetters(['version', 'locale']),
    displayedPrice () {
      if (!this.product) {
        return null
      }
      if (this.product.price_with_options) {
        return this.product.price_with_options
      }
      return this.product.price
    },
    hasHiddenUnits () {
      return this.product && parseInt(this.product.hide_units)
    },
    currentUnitStr () {
      let unitStr = ''
      if (parseInt(this.product.hide_units)) {
        return unitStr
      }
      const resourceUnitMultipliers = []
      const descArr = []
      if (this.product.ownProduct_resource) {
        for (let i = 0; i < this.product.ownProduct_resource.length; i++) {
          const link = this.product.ownProduct_resource[i]
          resourceUnitMultipliers[link.resource_id] = parseInt(link.units, 10)
        }
        for (let i = 0; i < this.product.sharedResource.length; i++) {
          const resource = this.product.sharedResource[i]
          descArr.push(resourceUnitMultipliers[resource.id] + ' ' + this.getFormattedUnit(resource.unit) + ' ' + resource.name)
        }
      }
      return descArr.join(', ')
    },
    previewModalId () {
      return this.column.identifier + '-component-' + this.activeComponent.id + '-product-' + this.product.id + '-preview'
    },
    productImage () {
      return (this.product.file_id ? this.baseDomain + this.productShopId + '/files/' + this.product.file_id + '.' +this.product.file_ext : 'data:image/gif;base64,R0lGODlhDwAKAJEAAAAAAP///////wAAACH5BAEHAAIALAAAAAAPAAoAAAIKlI+py+0Po5xUFgA7')
    },
    productCountValues () {
      let returnValues = []
      for (let i = 0; i < 50; i++) {
        returnValues.push(i+1)
      }
      return returnValues;
    }
  },
  methods: {
    getFormattedUnit (unit) {
      switch(unit) {
        case 'pcs':
          return this._('pcs')
        case 'm2':
          return 'm²'  // 'm&#178;';
        case 'm3':
          return 'm³' // 'm&#179;';
        default:
          return unit
      }
    },
    showPreviewModal () {
      this.$modal.show(this.previewModalId)
    },
    hidePreviewModal () {
      this.$modal.hide(this.previewModalId)
    },
    addProductToBasket () {
      let $this = this
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        shopId: this.productShopId,
        count: this.productCount
      }
      if (this.hasSelectableResources) {
        for (var poolId in this.selectedResources) {
          if (Object.prototype.hasOwnProperty.call(this.selectedResources, poolId)) {
            data['pool_' + poolId] = this.selectedResources[poolId]
          }
        }
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        if (parseInt(data.product.subtype) === 7) {
          $this.showAddedToBasketNotification($this.$filters.marketingname($this.product), 'warn')
        } else {
          $this.showAddedToBasketNotification($this.$filters.marketingname($this.product))
        }
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
      this.productCount = 1
    },
    hasSelectableResources () {
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return false
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (parseInt(this.product.sharedResourcepool[i].selectable)) {
          return true
        }
      }
      return false
    },
    selectableResourcePools () {
      let pools = []
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return pools
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (parseInt(this.product.sharedResourcepool[i].selectable) && this.product.sharedResourcepool[i].sharedResource && this.product.sharedResourcepool[i].sharedResource.length > 0) {
          pools.push(this.product.sharedResourcepool[i])
        }
      }
      return pools
    }    
  }
}
</script>